import { useEffect } from "react";

/**
 * Injecte un bloc <script type="application/ld+json"> dans le <head>
 * pour exposer du Schema.org / JSON-LD au crawler Google (rich snippets).
 *
 * Le bloc est identifié par un `id` HTML pour pouvoir être remplacé
 * proprement lors du changement de page (et nettoyé au démontage).
 *
 * @param {string} id     id HTML unique du script (ex: "ld-product")
 * @param {object} data   objet JSON sérialisable représentant le schéma
 */
const JsonLd = ({ id, data }) => {
  useEffect(() => {
    if (!data) return;
    let el = document.getElementById(id);
    if (!el) {
      el = document.createElement("script");
      el.setAttribute("type", "application/ld+json");
      el.setAttribute("id", id);
      document.head.appendChild(el);
    }
    el.textContent = JSON.stringify(data);
    return () => {
      const existing = document.getElementById(id);
      if (existing) existing.remove();
    };
  }, [id, data]);

  return null;
};

export default JsonLd;
